import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { NgForm } from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { ApiService } from '../../services/api.service';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {

  @ViewChild('f', { read: NgForm }) form: any;
  
  resetPassword: boolean = false;
  emailInvalid: boolean = false;
  controlStatus: any = {
    email: false
  };
  userName: any = ''
  submitted: boolean = false;
  constructor(
    private router: Router,
    public loadingController: LoadingController,
    public _commonService: CommonService,
    private _apiService: ApiService,
    public _translationService: TranslationService) {}

  ngOnInit() {
  }

  gotoLogin() {
    this.resetPassword = false;
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  ionViewWillEnter() {
    if( this._commonService.tempEmail){
      this.userName = this._commonService.tempEmail
    }
    this._commonService.isLoggedIn = false;
    localStorage.authenticationKey = "";
  }

  onChangeInput(){
    this.form.submitted  = false
  }

  async forgotPassword(f: NgForm) {
    this.submitted = true
    if (f.valid) {
      try{
        this._commonService.presentLoading();
        let params = {
          "Username": f.value.email.trim(),
          "localeCode" : localStorage.locale,
        };
        let response = await this._apiService.passwordChangeRequest(params);
        this.resetPassword = true;
        this._commonService.dismiss();
      } catch(error) {
        this._commonService.dismiss();
       
        this._commonService.log(error.message || error.statusText , this._commonService.ERROR)
      }
      
    }else{
      this.controlStatus.email = true
    }
  }

  
  onBlurMethod(controlName){
    if(controlName == 'email'){
      this.controlStatus.email = true
    }
   }
 
   onFocusMethod(controlName){
     if(controlName == 'email'){
       this.controlStatus.email = false
     }
   }

}
